import React, { useEffect, useState } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { Table, Button, Form } from 'antd';
import OriginalAccount from './OriginalAccount';
import { XrefDetails } from '../XrefDetails/XrefDetails';
import Details from './Details';
import CommentBox from '../shared/CommentBox';
import './errorDetails.css';
import {
  getReviewByReviewId,
  updateErrorDetailComments,
  updateErrorDetails,
  updateErrorRecord,
} from '../../apis/errorRecordsApis';
import { useOktaAuth } from '@okta/okta-react';

const mapComments = (records) =>
  records.map((record) => [[record.id], record.comment]);

function ErrorDetails() {
  const history = useHistory();
  const location = useLocation();
  const { authState } = useOktaAuth();
  const accessToken = authState.accessToken?.accessToken;

  const [dataFromDashboard, setDataFromDashboard] = useState(null); // get list of all assignee and error Id from  history pathname and state
  const [errorDetails, setErrorDetails] = useState([]);
  const [originalRequestDetails, setOriginalRequestDetails] = useState({});
  const [allAssignee, setAllAssignee] = useState(null); //List of all assignee
  const [originalAssignee, setOriginalAssignee] = useState(null); // store original selected assignee object

  const [assigneeId, setAssigneeId] = useState(null); // when assignee is changed, store the id
  const [status, setStatus] = useState(null); // when status is changed, store
  const [loading, setLoading] = useState(false);
  const [comments, setComments] = useState({});
  const { reviewId } = useParams();

  useEffect(() => {
    async function fetchData() {
      setDataFromDashboard(location.state.data); // Get error details for details sectiion
      setAllAssignee(location.state.allAssignee); // set List of all assignee for details section dropdown
      setAssigneeId(location.state.data.data_steward_id); // set Original Assignee id
      setStatus(location.state.data.status); //set original status

      const selectedAssignee = (location.state.allAssignee || []).find(
        (item) => item.id === location.state.data.data_steward_id
      );
      if (selectedAssignee) {
        setOriginalAssignee(selectedAssignee);
      }

      const review = await getReviewByReviewId(location.state.id, accessToken);
      setOriginalRequestDetails(review.originalRequestDetails);
      setErrorDetails(review.errorDetails);
      const mappedComments = Object.fromEntries(
        mapComments(review.errorDetails)
      );
      setComments(mappedComments);
    }
    fetchData();
  }, []);

  const getIds = (errorDetails) => {
    if (errorDetails.length !== 0 && errorDetails.length > 0) {
      return errorDetails.map((errorDetail) => ({
        bp_id: errorDetail.bp_id,
        id: errorDetail.id,
        review_id: errorDetail.review_id,
        gln_id: errorDetail.gln,
        name: errorDetail.legal_name,
        houseNumber: errorDetail.houseNumber,
        bp_flag: true,
      }));
    } else {
      const glnPayload = [
        {
          bp_id: '',
          id: '',
          review_id: '',
          gln_id: originalRequestDetails.grower_gln,
          bp_flag: false,
        },
      ];
      //setErrorDetails(glnPayload);
      return glnPayload;
    }
  };

  const refreshData = async () => {
    setLoading(true);
    const errorRecords = getIds(errorDetails);
    const updatedErrorDetails = await updateErrorDetails(
      errorRecords,
      accessToken
    );
    setErrorDetails(updatedErrorDetails);
    setLoading(false);
  };

  function handleAssigneeChange(id) {
    setAssigneeId(id);
  }

  function handleStatusChange(value) {
    setStatus(value);
  }

  const onFinish = async (comments) => {
    setLoading(true);
    await updateErrorRecord(
      {
        assigneeId: Number(assigneeId),
        originalId: dataFromDashboard.data_steward_id,
        status,
        reviewId,
      },
      accessToken
    );
    // .then(function (response) {
    //   if (response.status === 200) {
    //     history.push({
    //       pathname: '/',
    //     });
    //   }
    // });
    const commentsToUpdate = Object.fromEntries(
      Object.entries(comments).filter(([_, v]) => v !== null)
    );
    console.log(commentsToUpdate);
    await updateErrorDetailComments(commentsToUpdate, accessToken);
    setLoading(false);
  };

  const columns = [
    {
      title: 'Information',
      children: [
        {
          title: 'Match Sequence Number',
          dataIndex: 'sequence_number',
          width: 200,
          render: (col, row) =>
            row.sequence_number === 0 ? undefined : row.sequence_number,
        },
        {
          title: 'MDG Primary GLN',
          dataIndex: 'gln',
          width: 200,
        },
        {
          title: 'BP ID',
          dataIndex: 'bp_id',
          width: 150,
        },
      ],
    },
    {
      title: 'Name & Address',
      children: [
        {
          title: 'Name',
          dataIndex: 'legal_name',
          width: 150,
        },
        {
          title: 'House Number',
          dataIndex: 'house_number',
          width: 150,
        },
        {
          title: 'P.O Box',
          dataIndex: 'po_box',
          width: 150,
        },
        {
          title: 'Street',
          dataIndex: 'street_name',
          width: 150,
        },
        {
          title: 'City',
          dataIndex: 'city',
          width: 150,
        },
        {
          title: 'State',
          dataIndex: 'state',
          width: 150,
        },
        {
          title: 'Zip',
          dataIndex: 'postal_code',
          width: 150,
        },
        {
          title: 'Country',
          dataIndex: 'country',
          width: 150,
        },
      ],
    },
    {
      title: 'Other Information',
      children: [
        {
          title: 'Last Updated Date/Time',
          dataIndex: 'last_updated',
          width: 150,
        },
        {
          title: 'Comments',
          dataIndex: 'comments',
          width: 150,
          render: (record, row) => (
            <CommentBox
              recordId={row.id}
              comments={comments}
              setComments={setComments}
            />
          ),
        },
      ],
    },
  ];

  return (
    <section className="container">
      <Form onFinish={() => onFinish(comments)}>
        <div className="heading textCenter">Error Details</div>
        <div className="accountSection">
          <OriginalAccount apiData={originalRequestDetails} />
          <div className="details">
            <Details
              dataFromDashboard={dataFromDashboard}
              allAssignee={allAssignee}
              originalAssignee={originalAssignee}
              handleAssigneeChange={handleAssigneeChange}
              handleStatusChange={handleStatusChange}
            />
          </div>
        </div>
        <hr />

        <Table
          columns={columns}
          dataSource={errorDetails}
          rowKey={(record) => record.id}
          scroll={{ x: 1800 }}
          expandable={{
            expandedRowRender: (record) => (
              <XrefDetails xrefData={record.xrefData} />
            ),
            rowExpandable: (record) => record.xrefData,
            fixed: 'left',
          }}
          expandRowByClick={true}
          loading={loading}
        />
        <div className="buttonContainer">
          <Button className="default-btn" onClick={() => refreshData()}>
            Refresh
          </Button>
          <Button
            className="default-btn"
            onClick={() => {
              history.push({
                pathname: '/',
              });
            }}
          >
            Cancel
          </Button>
          <Button type="primary" htmlType="submit">
            Save
          </Button>
        </div>
      </Form>
    </section>
  );
}
export default ErrorDetails;
